const CurrencyModel = {};

// CurrencyModel.EU = '€';
// CurrencyModel.USA = '$';
// CurrencyModel.RU = '₽';

CurrencyModel.position = {
  before: 0,
  after: 1,
};

CurrencyModel.USD = {
  id: 1,
  title: 'USD',
  position: CurrencyModel.position.before,
  symbol: '$',
};

CurrencyModel.EUR = {
  id: 2,
  title: 'EUR',
  position: CurrencyModel.position.after,
  symbol: '€',
};

// CurrencyModel.RUB = {
//   id: 3,
//   title: 'RUB',
//   position: CurrencyModel.position.after,
//   symbol: '₽',
// };

CurrencyModel.LIST = [
  CurrencyModel.USD,
  CurrencyModel.EUR,
  // CurrencyModel.RUB,
];

CurrencyModel.ID_TO_DATA = {
  [CurrencyModel.USD.id]: CurrencyModel.USD,
  [CurrencyModel.EUR.id]: CurrencyModel.EUR,
  // [CurrencyModel.RUB.id]: CurrencyModel.RUB,
};

export default CurrencyModel;
